import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let tracked = false;

export function trackPageView(page) {
  if (tracked && page === '/') return;
  tracked = true;

  const data = {
    page: page || window.location.pathname,
    referrer: document.referrer || '',
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
  };

  axios.post(`${API}/track`, data).catch(() => {});
}
